import React, { useState, useContext } from "react";
import { STORAGE_KEYS, getFromStorage } from "../constants";

interface LanguageContextType {
  language: string;
  changeLanguage: (lang: string) => void;
}
const LanguageContext = React.createContext<LanguageContextType>({
  language: "en",
  changeLanguage: () => {},
});
export const useLanguageContext = () => useContext(LanguageContext);
export default function LanguageContextProvider({
  children,
}: {
  children: any;
}) {
  const lang = getFromStorage(STORAGE_KEYS.language);
  console.log(lang,"lang");
  
  const [language, changeLanguage] = useState(`${lang}` || "en");

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
